import { tracked } from "@glimmer/tracking";
import Controller from "@ember/controller";
import { action } from "@ember/object";

export default class extends Controller {
  /** @type {string | null} */
  @tracked tagsForUser = null;
  @tracked sortedByCount = true;
  @tracked sortedByName = false;
  @tracked sortProperties = ["count:desc", "name"];

  @action
  sortByCount(event) {
    event?.preventDefault();

    this.sortProperties = ["count:desc", "name"];
    this.sortedByCount = true;
    this.sortedByName = false;
  }

  @action
  sortById(event) {
    event?.preventDefault();

    this.sortProperties = ["name"];
    this.sortedByCount = false;
    this.sortedByName = true;
  }
}
